import React, {FunctionComponent} from 'react'
import classnames from 'classnames'
import StylesType from '@/types/StylesType'
import './style/Top.less'

interface TopProps {
    selected: number;
    changeSelect: (index: number) => void;
}



const OrderTop: FunctionComponent<TopProps & StylesType> =(props) => {
    let {prefixCls = 'gc_order_Nav', selected, changeSelect} = props

    let navList = [{
        title: '设备订单'
    }, {
        title: '增值订单'
    }]
    return (
        <div className={classnames(prefixCls)}>
            <ul>
                {navList.map((nav, index) => {
                    return <li key={index} className={classnames({actived: selected === index})}
                        onClick={()=>changeSelect(index)}
                    >{nav.title}</li>
                })}
            </ul>
        </div>
    )
}

export default OrderTop
